@if (service(); as service) {
<div class="layout-column layout-gt-sm-row full-height threepl-service-view" appBringozIdGenerator="threepl-service-view">

  <div class="layout-column left-side-panel">
    <div class="layout-column padding-20">
      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600"># {{ service.id }}</span>
        <app-service-type-indication class="margin-left-5" [serviceType]="service.serviceType" [isShort]="false"></app-service-type-indication>
        <span class="flex"></span>
        <bz-tag [tone]="service.status | threeplStatusTone" class="margin-right-5">{{ service.status | translate }}</bz-tag>
        <app-threepl-service-actions *ngxPermissionsOnly="updatePermissions"
                                     [service]="service"
                                     (addNote)="onAddNote($event)"
                                     (moveToInternal)="onMoveToInternal($event)"
                                     (cancel)="onCancel($event)">
        </app-threepl-service-actions>
      </div>

      @if (validateTaskApprovalStatus) {
        <div class="layout-column margin-top-10">
          <span class="br-body-2 margin-bottom-5 threepl-approval">{{ 'Approval Status' | translate }}</span>
          @if (service.pickup) {
            <div class="layout-row layout-align-start-center">
              <span class="PICKUP br-body-2 font-weight-600">{{ 'THIRD_PARTY_TASK_TYPE.' + service.pickup.type | translate }}:</span>
              @if (service.threePlExtraData?.pickupApprovalInfo?.contractorApprovalStatus; as status) {
                <span class="margin-left-10 br-body-2 threepl-approval">{{ 'TASK_APPROVAL_STATUS.' + status | translate }}</span>
              } @else {
                <span class="margin-left-10 br-body-2">---</span>
              }
              <span class="margin-left-10 br-body-2">{{ service.threePlExtraData?.pickupApprovalInfo?.approvalVehicleLicensePlanteNumber }}</span>
            </div>
          }
          <div class="layout-row layout-align-start-center">
            <span class="br-body-2 font-weight-600" [class]="service.destination?.type">{{ 'THIRD_PARTY_TASK_TYPE.' + service.destination?.type | translate }}:</span>
            @if (service.threePlExtraData?.destinationApprovalInfo?.contractorApprovalStatus; as status) {
              <span class="margin-left-10 br-body-2 threepl-approval">{{ 'TASK_APPROVAL_STATUS.' + status | translate }}</span>
            } @else {
              <span class="margin-left-10 br-body-2">---</span>
            }
            <span class="margin-left-10 br-body-2">{{ service.threePlExtraData?.destinationApprovalInfo?.approvalVehicleLicensePlanteNumber }}</span>
          </div>
        </div>
      }

      <bz-divider class="margin-top-20 margin-bottom-20"></bz-divider>

      <div class="threepl-service-warning">
        <div class="layout-row layout-align-start-center threepl-service-warning-header padding-10 br-body-2 font-weight-600 gap-5">
          <bz-icon class="margin-left-5" [icon]="icons.info" size="xl"></bz-icon>
          <span>{{ 'threePL' | translate }}</span>
          <span>-</span>
          <span>{{ 'TPL_PROVIDER_TYPE.' + service.providerType | translate }}</span>
        </div>
        <div class="threepl-service-warning-body padding-10 br-body-2">
          {{ 'Due to 3PL delivery, certain details / actions may not be available' | translate }}
        </div>
      </div>
    </div>

    <div class="margin-top-10 overflow-auto">
      <div class="padding-20">
        <div class="layout-row margin-bottom-5 threepl-field">
          <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.volume"></bz-icon><span class="br-body-2">{{ 'Total Volume' | translate }}</span></div>
          <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis"><span>{{ service.items | servicePackageVolume: true }}</span></div>
        </div>
        <div class="layout-row margin-bottom-5 threepl-field">
          <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.weight"></bz-icon><span class="br-body-2">{{ 'Total Weight' | translate }}</span></div>
          <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis"><span>{{ service.items | servicePackageWeight: true }}</span></div>
        </div>
        <div class="layout-row margin-bottom-5 threepl-field">
          <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.items"></bz-icon><span class="br-body-2">{{ 'Total Items' | translate }}</span></div>
          <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis"><span>{{ totalItems() }}</span></div>
        </div>

        <bz-divider class="margin-top-20 margin-bottom-20"></bz-divider>

        @if (derived()?.omsOrderIds?.length) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.hash"></bz-icon><span class="br-body-2">{{ 'Order ID' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">
              <app-bringoz-items-link-list state="order.info" [ids]="derived().omsOrderIds" [maxDisplay]="2" permission="oms.orders.get"></app-bringoz-items-link-list>
            </div>
          </div>
        }
        <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
          <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.created"></bz-icon><span class="br-body-2">{{ 'Created at' | translate }}</span></div>
          <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">{{ service.createdAt | date }}</div>
        </div>
        @if (service.externalId) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.label"></bz-icon><span class="br-body-2">{{ 'External ID' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2">
              <span class="text-ellipsis" container="body" [ngbTooltip]="service.externalId">{{ service.externalId }}</span>
            </div>
          </div>
        }
        @if (service.providerServiceExternalId) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.label"></bz-icon><span class="br-body-2">{{ 'Provider Service External ID' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2">
              <span class="text-ellipsis" container="body" [ngbTooltip]="service.providerServiceExternalId">{{ service.providerServiceExternalId }}</span>
            </div>
          </div>
        }
        @if (service.tagNames?.length) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.tag"></bz-icon><span class="br-body-2">{{ 'Tags' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2"><app-bringoz-tags [tags]="service.tagNames"></app-bringoz-tags></div>
          </div>
        }
        @if (service.vehicleType) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.vehicle"></bz-icon><span class="br-body-2">{{ 'Vehicle' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">{{ service.vehicleType | translate }}</div>
          </div>
        }
        @if (service.distance) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.car"></bz-icon><span class="br-body-2">{{ 'Distance' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">{{ service.distance | bringozDistance: '---' : true : 1 }}</div>
          </div>
        }
        <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
          <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.program"></bz-icon><span class="br-body-2">{{ 'Program type' | translate }}</span></div>
          <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">
            <app-threepl-service-chips [items]="derived()?.programNames"></app-threepl-service-chips>
            @if (!derived()?.programNames?.length && service.programType) {
              <span>{{ sitePrograms[service.programType] }}</span>
            }
          </div>
        </div>

        <bz-divider class="margin-top-20 margin-bottom-20"></bz-divider>

        <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
          <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.account"></bz-icon><span class="br-body-2">{{ 'Account' | translate }}</span></div>
          <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">
            @if (service.fulfillmentStepInfoList?.[0]?.accountReference; as account) {
              <app-demand-account-link [account]="account" [isAllowCopyButton]="true"></app-demand-account-link>
            }
          </div>
        </div>
        <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
          <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.carrier"></bz-icon><span class="br-body-2">{{ 'Carrier' | translate }}</span></div>
          <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">
            <app-supply-account-link class="text-ellipsis-multi-lines-2" [account]="service.supplierAccountReference"></app-supply-account-link>
          </div>
        </div>
        @if (service.threePlExtraData?.driverName) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.driver"></bz-icon><span class="br-body-2">{{ 'Driver' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">{{ service.threePlExtraData.driverName }}</div>
          </div>
        }
        @if (service.threePlExtraData?.driverPhoneNumber) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.phone"></bz-icon><span class="br-body-2">{{ 'Driver phone' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis" data-sl="mask">{{ service.threePlExtraData.driverPhoneNumber | bringozPhone }}</div>
          </div>
        }
        @if (derived()?.branchIds?.length) {
          <div class="layout-row layout-align-start-center margin-bottom-5 threepl-field">
            <div class="flex layout-row layout-align-start-center"><bz-icon [icon]="icons.branch"></bz-icon><span class="br-body-2">{{ 'Operational unit' | translate }}</span></div>
            <div class="flex layout-row layout-align-end-center br-body-2 text-ellipsis">
              <branches-indicator [branchIds]="branchIdsInput()"></branches-indicator>
            </div>
          </div>
        }

        <div class="layout-column margin-top-20">
          <div class="layout-row layout-align-start-center">
            <bz-icon class="margin-right-5 primary-102" [icon]="icons.pricing"></bz-icon>
            <span class="br-body-2 font-weight-600">{{ 'Pricing' | translate }}</span>
          </div>
          <bz-divider class="margin-top-10 margin-bottom-20"></bz-divider>
          <div class="layout-row layout-align-start-center br-body-2">
            <span>{{ 'Total price' | translate }}</span>
            <span class="flex"></span>
            <span>{{ service.price | bringozPrice: undefined : service.threePlExtraData?.currency }}</span>
          </div>
          @if (service.itemsEstimatedValue) {
            <div class="layout-row layout-align-start-center br-body-2">
              <span>{{ 'Goods Price' | translate }}</span>
              <span class="flex"></span>
              <span>{{ service.itemsEstimatedValue | bringozPrice: undefined : service.threePlExtraData?.currency }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="layout-row flex threepl-service-main">
    <div class="flex layout-column">
      <bz-tabs class="threepl-service-tabs" appBringozIdGenerator="threepl-service-tabs" [tabs]="tabs()" [selectedId]="selectedTab()" (selectedIdChange)="onTabChange($event)"></bz-tabs>
      <div class="flex layout-column overflow-auto threepl-service-tab-body">
        @switch (selectedTab()) {
          @case ('info') {
            <div class="layout-column threepl-service-info">
            @if (service.pickup) {
              <div class="layout-column">
                <div class="layout-row layout-align-start-center header padding-top-10 padding-bottom-10 padding-left-20 padding-right-20">
                  <span class="PICKUP br-body-2 font-weight-600">{{ 'THIRD_PARTY_TASK_TYPE.' + service.pickup.type | translate }}</span>
                  <span class="flex"></span>
                  <bz-tag [tone]="service.pickup.status | threeplStatusTone">{{ service.pickup.status | translate }}</bz-tag>
                </div>
                <div class="padding-20"><app-threepl-service-task [task]="service.pickup"></app-threepl-service-task></div>
              </div>
            }
            @if (service.destination) {
              <div class="layout-column">
                <div class="layout-row layout-align-start-center header padding-top-10 padding-bottom-10 padding-left-20 padding-right-20">
                  <span class="br-body-2 font-weight-600" [class]="service.destination.type">{{ 'THIRD_PARTY_TASK_TYPE.' + service.destination.type | translate }}</span>
                  <span class="flex"></span>
                  <bz-tag [tone]="service.destination.status | threeplStatusTone">{{ service.destination.status | translate }}</bz-tag>
                </div>
                <div class="padding-20"><app-threepl-service-task [task]="service.destination"></app-threepl-service-task></div>
              </div>
            }
            <bz-card [padded]="false" class="threepl-service-card threepl-service-items">
              <app-service-items-table [items]="service.items ?? []" [settings]="settings"></app-service-items-table>
            </bz-card>
            <div class="layout-column">
              <div class="header padding-top-10 padding-bottom-10 padding-left-20 padding-right-20"><span class="br-body-2 font-weight-600 primary-102">{{ 'Additional Information' | translate }}</span></div>
              <div class="padding-20">
                <app-threepl-provider-extra-data-view [providerType]="service.providerType" [extraData]="service.threePlExtraData"></app-threepl-provider-extra-data-view>
              </div>
            </div>
            @if (serviceMetaData.length) {
              <bz-card [padded]="false" class="threepl-service-card">
                <div class="layout-row layout-align-start-center padding-10 threepl-card-header">
                  <span class="flex br-body-2 font-weight-400 gray-102">{{ 'Customized Service Fields' | translate }}</span>
                  <span class="flex br-body-2 font-weight-400 gray-102">{{ 'Value' | translate }}</span>
                </div>
                <div class="threepl-card-body">
                  @for (metaData of serviceMetaData; track metaData.key) {
                    <div class="layout-row layout-align-start-center margin-bottom-5">
                      <div class="flex layout-row"><span class="br-body-2 text-ellipsis">{{ metaData.title }}</span></div>
                      <div class="flex layout-row layout-wrap">
                        <div class="br-body-1 font-weight-400 dark-grey">{{ derived()?.dynamicColumnsMap[metaData.key]?.value || '---' }}</div>
                      </div>
                    </div>
                  }
                </div>
              </bz-card>
            }
            @if (service.notes?.length) {
              <div class="layout-column">
                <div class="header padding-top-10 padding-bottom-10 padding-left-20 padding-right-20"><span class="br-body-2 font-weight-600 primary-102">{{ 'Service Notes' | translate }}</span></div>
                <div class="padding-20 layout-column"><app-bringoz-notes-list [notes]="service.notes"></app-bringoz-notes-list></div>
              </div>
            }
            </div>
          }
          @case ('timeline') {
            <app-threepl-service-timeline class="flex" [serviceId]="service.id"></app-threepl-service-timeline>
          }
          @case ('map') {
            <app-threepl-service-map class="flex" [service]="service"></app-threepl-service-map>
          }
        }
      </div>
    </div>

    @if (isLargeScreen()) {
      <div class="flex layout-column">
        @if (!isShowMap()) {
          <div class="flex static-map-container overflow-hidden">
            <img src="assets/images/map/static-map.png" class="static-map" alt="">
            <bz-button class="show-map-btn" tone="secondary" appBringozIdGenerator="threepl-service-show-map-button" (clicked)="showMap()">
              <bz-icon [icon]="icons.map"></bz-icon>
              {{ 'Show Map' | translate }}
            </bz-button>
          </div>
        } @else {
          <app-threepl-service-map class="flex" [service]="service"></app-threepl-service-map>
        }
      </div>
    }
  </div>
</div>
} @else if (loadFailed()) {
  <bz-empty-state [title]="'Service not found' | translate"></bz-empty-state>
} @else {
  <div class="layout-column layout-align-center-center full-height"><bz-spinner [label]="'Loading' | translate"></bz-spinner></div>
}
